window.i18ntable = window.i18ntable || {};

class Translate {
	static setLocale(lang) {
		return new Promise( (resolve, reject) => {
			let id = lang? lang: window.navigator.language;
			console.log('id', id);
			const LOCALE_REGEX = /([a-z]{2})-/;
			const listLocales = [
				{ key: 'en', display_name: 'English'},
				{ key: 'ko', display_name: 'Korean'},
				{ key: 'zh', display_name: 'Chinese'},
				{ key: 'ja', display_name: 'Japanese'}
			];

			let currentLocale = id;
			let currentLocaleShourtcut = id;

			if( LOCALE_REGEX.test(id) ) {
				currentLocaleShourtcut = id.substring(0,2);
				currentLocale = currentLocaleShourtcut;
			}

			let urlWebconsole = '/locales/' + currentLocaleShourtcut + '.json';
			let urlLogpresso = '/package/logpresso/locales/' + currentLocaleShourtcut + '.json';

			let request = (url) => {
				return new Promise( (resolve, reject) => {
					let requestUrl = $.get(url)

					requestUrl
					.success( locale => {
						resolve(locale)
					})
					.error( (jqXHR, status, error) => {
						reject(new Error('cannot load json : ' + error));
					})
				});
			}

			if(LOCALE_REGEX.test(id)) {
				currentLocaleShourtcut = id.substring(0,2);
				currentLocale = currentLocaleShourtcut;
			}

			if( !( listLocales.some(locale => {return locale.key === currentLocaleShourtcut})) ) {
				currentLocaleShourtcut = 'en';
				currentLocale = 'en';
			}

			Promise.all([request(urlWebconsole), request(urlLogpresso)])
			.then( locales => {
				console.info('load i18ntable success');
				locales.forEach(locale => {
					Object.assign(i18ntable, JSON.parse(locale));
				});
				resolve();
			})
			.catch(error => {
				reject();
				console.error(error);
			})
		});
	}

	static expressionTemplate(str, keys) {
		return str.replace(/{{[^{}]+}}/g, (key) => {
			return ''+keys[key.replace(/[{}]+/g, '')] || '';
		});
	}

	static get(key, args) {
		if(!key || key === '') {
			return ;
		}

		let translated = undefined;
		if(!!i18ntable && Object.keys(i18ntable).length) {
			// console.log('i18ntable', i18ntable);
			translated = i18ntable[key];
			if(!!args) {
				translated = Translate.expressionTemplate(translated, args);
			}
			
		}

		if(typeof translated === 'undefined') {
			console.error('Translate Error: Cannot match the value of this key: ' + key);
			return key;
		}

		return translated;
	}
}

export default Translate;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Translate.js